module.exports = __webpack_public_path__ + "static/media/icon-passo2.befdd0ce.svg";